import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || typeof supabaseUrl !== 'string' || !supabaseUrl.startsWith('https')) {
  throw new Error(`A VITE_SUPABASE_URL no arquivo .env está inválida ou não foi encontrada. Valor recebido: "${supabaseUrl}". Verifique se o valor começa com "https://".`);
}

if (!supabaseAnonKey || typeof supabaseAnonKey !== 'string') {
  throw new Error("A VITE_SUPABASE_ANON_KEY no arquivo .env está inválida ou não foi encontrada. Por favor, verifique o arquivo.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)